/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Korean
export default {
  'team-central.give-jira-kudos.created.description.flag': 'Workplace Experience 팀이 이제 선물 요청을 처리할 것입니다. ✨',
  'team-central.give-jira-kudos.created.title.flag': '칭찬을 만듦',
  'team-central.give-jira-kudos.creation.failed.description.flag': '칭찬을 보냈지만 오류로 인해 선물을 보낼 수 없습니다. <a>go/kudos</a>에서 별도의 티켓을 제기하세요.',
  'team-central.give-jira-kudos.creation.failed.title.flag': '선물을 보낼 수 없음',
  'team-central.give-kudos.button': '칭찬하기',
  'team-central.give-kudos.close-button.label': '서랍 닫기',
  'team-central.give-kudos.confirm-close.title': '닫기 확인',
  'team-central.give-kudos.created.description.flag': '칭찬을 보냈습니다. <a>칭찬 보기</a>',
  'team-central.give-kudos.created.title.flag': '칭찬을 만듦',
  'team-central.give-kudos.success-icon.label': '성공',
  'team-central.give-kudos.unsaved.warning': '변경 사항이 저장되지 않습니다.',
  'team-central.give-kudos.unsaved.warning.cancel': '취소',
  'team-central.give-kudos.unsaved.warning.close': '닫기'
};